<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col cols="6" class="text-center text-sm-left mb-4 mb-sm-0 ui-title-text">
        <span class="text-uppercase page-subtitle">Strona główna</span>
        <h3 class="page-title">Witaj w panelu</h3>
      </d-col>

      <d-col cols="6" class="text-right ui-title-buttons">
        <d-button
          theme="primary"
          class="mt-3"
          @click.prevent="loadData"
          :disabled="!loaded">
          <template v-if="loaded">
            <i class="material-icons">refresh</i>
            <span class="ui-button-label">Odśwież</span>
          </template>
          <template v-if="!loaded">
            <div
              class="spinner-border spinner-border-sm"
              role="status"></div>
          </template>
        </d-button>

        <d-button
          theme="danger"
          class="mt-3 ml-3"
          @click.prevent="$router.push('/wyloguj')">
          <i class="material-icons">logout</i>
          <span class="ui-button-label">Wyloguj</span>
        </d-button>
      </d-col>
    </d-row>

    <d-row v-if="!loaded">
      <d-alert
        show
        theme="light"
        class="text-center w-100">
        Trwa wczytywanie danych...
      </d-alert>
    </d-row>

    <template v-if="loaded">
      <d-row
        v-if="!hasPatternItems && !hasSewingItems">
        <d-alert
          show
          theme="warning"
          class="text-center w-100">
          Brak zleceń do wykonania...
        </d-alert>
      </d-row>

      <d-row
        v-if="hasPatternItems"
        key="order-group-pattern"
        class="my-4 px-3">
        <h4 class="pt-3 mb-4 mt-3">
          Wykrajanie
          <d-badge
            class="ml-2"
            style="position: relative; top: -2px;">
            {{ patternItemsCount }}
          </d-badge>
        </h4>

        <d-card class="w-100 is-hidden-on-mobile">
          <table class="table mt-0 mb-0 full-width items-list">
            <thead class="bg-light">
              <tr>
                <th scope="col" class="border-0">Nazwa zamówienia</th>
                <th scope="col" class="border-0" style="width: 360px">Terminy</th>
                <th scope="col" class="border-0" style="width: 300px;">Produkt</th>
                <th scope="col" class="border-0" style="width: 300px;">Informacje dodatkowe</th>
                <th scope="col" class="border-0">Realizacja</th>
                <th scope="col" class="border-0" style="width: 140px;">Wykonanie</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) of patternItems"
                :key="'pattern-item-' + index">
                <td class="align-middle">
                  <d-badge
                    v-if="item.remote_job"
                    theme="success">
                    Praca zdalna
                  </d-badge>
                  <br v-if="item.remote_job">

                  <small>
                    <strong>{{ item.order_name }}</strong>
                    <br>
                    ID zamówienia: #{{ item.order_id }}
                  </small>
                </td>

                <td class="align-middle">
                  <div v-if="item.remote_job">
                    <small>
                      <strong>Data dostawy:</strong>
                      {{ item.remote_job.planned_collection_date }}
                    </small>
                  </div>
                  <div>
                    <small>
                      <strong>
                        Otrzymano:
                      </strong>
                      {{ item.created_at }}
                    </small>
                  </div>
                  <div :class="dateColor(item.end_at)">
                    <small>
                      <strong>
                        Termin:
                      </strong>
                      {{ item.end_at }}
                    </small>
                  </div>
                  <div v-if="item.remote_job">
                    <small>
                      <strong>
                        Data odbioru:
                      </strong>
                      {{ item.remote_job.planned_delivery_date }}
                    </small>
                  </div>

                  <div v-if="item.schedules.length">
                    <small
                      v-if="!itemsScheduleOpened[index]"
                      class="text-primary cursor-pointer"
                      @click="toggleSchedule(itemsScheduleOpened, index, true)">
                      Zobacz obłożenie
                    </small>
                    <small
                      v-if="itemsScheduleOpened[index]"
                      class="text-primary cursor-pointer"
                      @click="toggleSchedule(itemsScheduleOpened, index, false)">
                      Schowaj obłożenie
                    </small>

                    <dl
                      v-if="itemsScheduleOpened[index]"
                      class="mt-2">
                      <template v-for="(schedule, index) of item.schedules">
                      <dt :key="'schedule-title-' + index">{{ schedule.date }} ({{ Math.ceil(schedule.daily_percent) }}%)</dt>
                      <dd :key="'schedule-desc-' + index">Wykonano: {{ schedule.quantity_done }} z {{ schedule.quantity }} szt.</dd>
                      </template>
                    </dl>
                  </div>
                </td>

                <td class="align-middle">
                  <dl>
                    <dt>
                      Kod produktu:
                    </dt>
                    <dd>
                      {{ item.product_code }}
                    </dd>

                    <template v-if="item.color_name">
                      <dt>
                        Kolor produktu:
                      </dt>
                      <dd>
                        {{ item.color_name }}
                      </dd>
                    </template>

                    <template v-if="item.polar_name">
                      <dt>
                        Kolor polaru:
                      </dt>
                      <dd>
                        {{ item.polar_name }}
                      </dd>
                    </template>
                  </dl>
                </td>

                <td class="align-middle">
                  <dl>
                    <dt>
                      Wykrój:
                    </dt>
                    <dd>
                      <span
                        v-if="item.pattern_before_order"
                        class="text-success">
                        Tak
                      </span>
                      <span
                        v-else
                        class="text-danger">
                        Nie
                      </span>
                    </dd>

                    <dt>
                      Zostaje w Hafciarni:
                    </dt>
                    <dd>
                      <span
                        v-if="item.pattern_stays"
                        class="text-success">
                        Tak
                      </span>
                      <span
                        v-else
                        class="text-danger">
                        Nie
                      </span>
                    </dd>

                    <template v-if="item.seam_name">
                      <dt>
                        Przeszycia:
                      </dt>
                      <dd>
                        {{ item.seam_name }}
                      </dd>
                    </template>

                    <template v-if="item.size_name">
                      <dt>
                        Rozmiar:
                      </dt>
                      <dd>
                        {{ item.size_name }}
                      </dd>
                    </template>

                    <template v-if="item.material_name">
                      <dt>
                        Materiał:
                      </dt>
                      <dd>
                        {{ item.material_name }}
                      </dd>
                    </template>

                    <template v-if="item.description">
                      <dt>
                        Uwagi:
                      </dt>
                      <dd>
                        {{ item.description }}
                      </dd>
                    </template>
                  </dl>
                </td>

                <td class="align-middle">
                  <span
                    :class="{
                      'text-success': item.quantity_done === item.quantity,
                      'text-danger': item.quantity_done < item.quantity && item.quantity_done > 0
                    }">
                    {{ item.quantity_done }} z {{ item.quantity }} szt.
                  </span>
                </td>

                <td class="align-middle">
                  <d-button
                    theme="success"
                    class="mt-2 w-100"
                    size="sm"
                    @click.prevent="openPopup(item)">
                    Aktualizuj
                  </d-button>
                </td>
              </tr>
            </tbody>
          </table>
        </d-card>

        <d-card
          v-for="(item, index) of patternItems"
          :key="'pattern-mobile-item-' + index"
          class="w-100 p-3 mb-3 is-visible-on-mobile">
          <d-badge
            v-if="item.remote_job"
            theme="success">
            Praca zdalna
          </d-badge>
          <br v-if="item.remote_job">

          <strong>Nazwa zamówienia:</strong><br>
          <small>
            <strong>{{ item.order_name }}</strong>
            <br>
            ID zamówienia: #{{ item.order_id }}
          </small>

          <hr class="my-2">

          <small>
            <template v-if="item.remote_job">
              <strong>Data dostawy:</strong> {{ item.remote_job.planned_collection_date }}<br>
            </template>
            <strong>Otrzymano:</strong> <span>{{ item.created_at }}</span><br>
            <strong>Termin:</strong> <span :class="dateColor(item.end_at)">{{ item.end_at }}</span>
            <template v-if="item.remote_job">
              <br><strong>Data odbioru:</strong> {{ item.remote_job.planned_delivery_date }}
            </template>
          </small>

          <hr
            v-if="item.schedules.length"
            class="my-2">

          <div v-if="item.schedules.length">
            <small
              v-if="!itemsScheduleOpened[index]"
              class="text-primary cursor-pointer"
              @click="toggleSchedule(itemsScheduleOpened, index, true)">
              Zobacz obłożenie
            </small>
            <small
              v-if="itemsScheduleOpened[index]"
              class="text-primary cursor-pointer"
              @click="toggleSchedule(itemsScheduleOpened, index, false)">
              Schowaj obłożenie
            </small>

            <dl
              v-if="itemsScheduleOpened[index]"
              class="mt-2">
              <template v-for="(schedule, index) of item.schedules">
              <dt :key="'schedule-mob-title-' + index">{{ schedule.date }} ({{ Math.ceil(schedule.daily_percent) }}%)</dt>
              <dd :key="'schedule-mob-desc-' + index">Wykonano: {{ schedule.quantity_done }} z {{ schedule.quantity }} szt.</dd>
              </template>
            </dl>
          </div>

          <hr class="my-2">

          <small>
            <strong>Kod produktu:</strong> {{ item.product_code }}

            <template v-if="item.color_name">
              <br>
              <strong>Kolor produktu:</strong> {{ item.color_name }}<br>
            </template>

            <template v-if="item.polar_name">
              <br>
              <strong>Kolor polaru:</strong> {{ item.polar_name }}
            </template>
          </small>

          <hr class="my-2">

          <small>
            <strong>Wykrój:</strong>
            <span v-if="item.pattern_before_order" class="text-success">Tak</span>
            <span v-else class="text-danger">Nie</span><br>

            <strong>Zostaje w Hafciarni:</strong>
            <span v-if="item.pattern_stays" class="text-success">Tak</span>
            <span v-else class="text-danger">Nie</span>

            <template v-if="item.seam_name">
              <br>
              <strong>Przeszycia:</strong> {{ item.seam_name }}
            </template>

            <template v-if="item.size_name">
              <br>
              <strong>Rozmiar:</strong> {{ item.size_name }}
            </template>

            <template v-if="item.material_name">
              <br>
              <strong>Materiał:</strong> {{ item.material_name }}
            </template>

            <template v-if="item.description">
              <br>
              <strong>Uwagi:</strong><br>
              {{ item.description }}
            </template>
          </small>

          <hr class="my-2">

          <d-row>
            <d-col cols="7" class="d-flex align-items-center">
              <small class="mt-1">
                <strong>
                  Realizacja:
                  <span
                    :class="{
                      'text-success': item.quantity_done === item.quantity,
                      'text-danger': item.quantity_done < item.quantity && item.quantity_done > 0
                    }">
                    {{ item.quantity_done }} z {{ item.quantity }} szt.
                  </span>
                </strong>
              </small>
            </d-col>
            <d-col cols="5">
              <d-button
                theme="success"
                class="mt-2 w-100"
                size="sm"
                @click.prevent="openPopup(item)">
                Aktualizuj
              </d-button>
            </d-col>
          </d-row>
        </d-card>
      </d-row>

      <d-row
        v-if="hasSewingItems"
        key="order-group-sewing"
        class="my-4 px-3">
        <h4 class="pt-3 mb-4 mt-3">
          Szycie
          <d-badge
            class="ml-2"
            style="position: relative; top: -2px;">
            {{ sewingItemsCount }}
          </d-badge>
        </h4>

        <d-card class="w-100 is-hidden-on-mobile">
          <validation-observer
            ref="sewing-forms"
            tag="div">
            <table class="table mt-0 mb-0 full-width items-list">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0">Nazwa procesu</th>
                  <th scope="col" class="border-0">Nazwa zamówienia</th>
                  <th scope="col" class="border-0" style="width: 360px">Terminy</th>
                  <th scope="col" class="border-0" style="width: 300px;">Produkt</th>
                  <th scope="col" class="border-0" style="width: 300px;">Informacje dodatkowe</th>
                  <th scope="col" class="border-0">Realizacja</th>
                  <th scope="col" class="border-0" style="width: 140px;">Wykonanie</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) of sewingItems"
                  :key="'sewing-item-' + index">
                  <td class="align-middle">
                    <small>
                      <strong>{{ item.process_name }}</strong>
                    </small>
                  </td>

                  <td class="align-middle">
                    <d-badge
                      v-if="item.remote_job"
                      theme="success">
                      Praca zdalna
                    </d-badge>
                    <br v-if="item.remote_job">

                    <small>
                      <strong>{{ item.order_name }}</strong>
                      <br>
                      ID zamówienia: #{{ item.order_id }}
                    </small>
                  </td>

                  <td class="align-middle">
                    <div v-if="item.remote_job">
                      <small>
                        <strong>Data dostawy:</strong>
                        {{ item.remote_job.planned_collection_date }}
                      </small>
                    </div>
                    <div :class="dateColor(item.end_at)">
                      <small>
                        <strong>
                          Termin:
                        </strong>
                        {{ item.end_at }}
                      </small>
                    </div>
                    <div v-if="item.remote_job">
                      <small>
                        <strong>
                          Data odbioru:
                        </strong>
                        {{ item.remote_job.planned_delivery_date }}
                      </small>
                    </div>

                    <div v-if="item.schedules.length">
                      <small
                        v-if="!itemsSewingScheduleOpened[index]"
                        class="text-primary cursor-pointer"
                        @click="toggleSchedule(itemsSewingScheduleOpened, index, true)">
                        Zobacz obłożenie
                      </small>
                      <small
                        v-if="itemsSewingScheduleOpened[index]"
                        class="text-primary cursor-pointer"
                        @click="toggleSchedule(itemsSewingScheduleOpened, index, false)">
                        Schowaj obłożenie
                      </small>

                      <dl
                        v-if="itemsSewingScheduleOpened[index]"
                        class="mt-2">
                        <template v-for="(schedule, index) of item.schedules">
                        <dt :key="'schedule-sewing-title-' + index">{{ schedule.date }} ({{ Math.ceil(schedule.daily_percent) }}%)</dt>
                        <dd :key="'schedule-sewing-desc-' + index">Wykonano: {{ schedule.quantity_done }} z {{ schedule.quantity }} szt.</dd>
                        </template>
                      </dl>
                    </div>
                  </td>

                  <td class="align-middle">
                    <dl>
                      <dt>
                        Kod produktu:
                      </dt>
                      <dd>
                        {{ item.product_code }}
                      </dd>
                    </dl>
                  </td>

                  <td class="align-middle">
                    <dl>
                      <template v-if="item.strand_name">
                        <dt>
                          Kolor nici:
                        </dt>
                        <dd>
                          {{ item.strand_name }}
                        </dd>
                      </template>

                      <template v-if="item.material_name">
                        <dt>
                          Materiał:
                        </dt>
                        <dd>
                          {{ item.material_name }}
                        </dd>
                      </template>

                      <template v-if="item.color_name">
                        <dt>
                          Kolor:
                        </dt>
                        <dd>
                          {{ item.color_name }}
                        </dd>
                      </template>

                      <template v-if="item.seam_name">
                        <dt>
                          Przeszycia:
                        </dt>
                        <dd>
                          {{ item.seam_name }}
                        </dd>
                      </template>

                      <template v-if="item.description">
                        <dt>
                          Uwagi:
                        </dt>
                        <dd>
                          {{ item.description }}
                        </dd>
                      </template>
                    </dl>
                  </td>

                  <td class="align-middle">
                    <span
                      :class="{
                        'text-success': item.quantity_done === item.quantity,
                        'text-danger': item.quantity_done < item.quantity && item.quantity_done > 0
                      }">
                      {{ item.quantity_done }} z {{ item.quantity }} szt.
                    </span>
                  </td>

                  <td class="align-middle">
                    <d-button
                      theme="success"
                      class="mt-2 w-100"
                      size="sm"
                      @click.prevent="openPopup(item)">
                      Aktualizuj
                    </d-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </validation-observer>
        </d-card>

        <d-card
          v-for="(item, index) of sewingItems"
          :key="'sewing-mobile-item-' + index"
          class="w-100 p-3 mb-3 is-visible-on-mobile">
          <d-badge
            v-if="item.remote_job"
            theme="success">
            Praca zdalna
          </d-badge>
          <br v-if="item.remote_job">

          <strong>Nazwa procesu:</strong>
          <br>
          <small>
            <strong>{{ item.process_name }}</strong>
          </small>
          <br>
          <strong>Nazwa zamówienia:</strong>
          <br>
          <small>
            <strong>{{ item.order_name }}</strong>
          </small>
          <br>
          <small>
            ID zamówienia: #{{ item.order_id }}
          </small>

          <hr class="my-2">

          <small>
            <template v-if="item.remote_job">
              <strong>Data dostawy:</strong> {{ item.remote_job.planned_collection_date }}<br>
            </template>
            <strong>Termin:</strong> <span :class="dateColor(item.end_at)">{{ item.end_at }}</span>
            <template v-if="item.remote_job">
              <br><strong>Data odbioru:</strong> {{ item.remote_job.planned_delivery_date }}
            </template>
          </small>

          <hr
            v-if="item.schedules.length"
            class="my-2">

          <div v-if="item.schedules.length">
            <small
              v-if="!itemsSewingScheduleOpened[index]"
              class="text-primary cursor-pointer"
              @click="toggleSchedule(itemsSewingScheduleOpened, index, true)">
              Zobacz obłożenie
            </small>
            <small
              v-if="itemsSewingScheduleOpened[index]"
              class="text-primary cursor-pointer"
              @click="toggleSchedule(itemsSewingScheduleOpened, index, false)">
              Schowaj obłożenie
            </small>

            <dl
              v-if="itemsSewingScheduleOpened[index]"
              class="mt-2">
              <template v-for="(schedule, index) of item.schedules">
              <dt :key="'schedule-sewing-mob-title-' + index">{{ schedule.date }} ({{ Math.ceil(schedule.daily_percent) }}%)</dt>
              <dd :key="'schedule-sewing-mob-desc-' + index">Wykonano: {{ schedule.quantity_done }} z {{ schedule.quantity }} szt.</dd>
              </template>
            </dl>
          </div>

          <hr class="my-2">

          <small>
            <strong>Kod produktu:</strong> {{ item.product_code }}
          </small>

          <hr class="my-2">

          <small>
            <template v-if="item.strand_name">
              <br>
              <strong>Kolor nici:</strong> {{ item.strand_name }}
            </template>

            <template v-if="item.material_name">
              <br>
              <strong>Materiał:</strong> {{ item.material_name }}
            </template>

            <template v-if="item.color_name">
              <br>
              <strong>Kolor:</strong> {{ item.color_name }}
            </template>

            <template v-if="item.seam_name">
              <br>
              <strong>Przeszycia:</strong> {{ item.seam_name }}
            </template>

            <template v-if="item.description">
              <br>
              <strong>Uwagi:</strong><br>
              {{ item.description }}
            </template>
          </small>

          <hr class="my-2">

          <d-row>
            <d-col cols="7" class="d-flex align-items-center">
              <small class="mt-1">
                <strong>
                  Realizacja:
                  <span
                    :class="{
                      'text-success': item.quantity_done === item.quantity,
                      'text-danger': item.quantity_done < item.quantity && item.quantity_done > 0
                    }">
                    {{ item.quantity_done }} z {{ item.quantity }} szt.
                  </span>
                </strong>
              </small>
            </d-col>
            <d-col cols="5">
              <d-button
                theme="success"
                class="mt-2 w-100"
                size="sm"
                @click.prevent="openPopup(item)">
                Aktualizuj
              </d-button>
            </d-col>
          </d-row>
        </d-card>
      </d-row>
    </template>

    <d-modal
      v-if="updatePopupVisible"
      class="realisation-form-popup"
      @close="closePopup">
      <d-modal-header>
        <d-modal-title>
          Aktualizuj stan realizacji
        </d-modal-title>
      </d-modal-header>
      <d-modal-body class="px-3 py-3">
        <validation-observer
          ref="realisation-form"
          tag="form">
          <p class="mb-3">
            Zrealizowano dotąd: {{ popupState.quantity_done }} z {{ popupState.quantity }} szt.
          </p>

          <validation-provider
            :rules="'required|min_value:1|max_value:' + (popupState.quantity - popupState.quantity_done)"
            name="items-done"
            v-slot="{ errors }">
            <div class="w-100 mb-2">
              <d-input-group
                append="szt."
                prepend="Oznacz jako zrealizowane:"
                :state="errors.length ? 'invalid' : null">
                <d-input
                  type="number"
                  :min="1"
                  :step="1"
                  :max="popupState.quantity - popupState.quantity_done"
                  :state="errors.length ? 'invalid' : null"
                  class="text-right"
                  v-model="popupState.done" />
              </d-input-group>
              <div class="invalid-feedback text-center">
                {{ errors[0] }}
              </div>
            </div>
          </validation-provider>

          <validation-provider
            :rules="'required|min_value:0'"
            name="items-additional"
            v-slot="{ errors }">
            <div class="w-100 mb-2">
              <d-input-group
                append="szt."
                prepend="Sztuki ekstra:"
                :state="errors.length ? 'invalid' : null">
                <d-input
                  type="number"
                  :min="0"
                  :step="1"
                  :state="errors.length ? 'invalid' : null"
                  class="text-right"
                  v-model="popupState.quantity_additional" />
              </d-input-group>
              <div class="invalid-feedback text-center">
                {{ errors[0] }}
              </div>
            </div>
          </validation-provider>

          <validation-provider
            :rules="'required|min_value:0|max_value:' + popupState.quantity"
            name="items-shortage"
            v-slot="{ errors }">
            <div class="w-100 mb-2">
              <d-input-group
                append="szt."
                prepend="BRAKI:"
                :state="errors.length ? 'invalid' : null">
                <d-input
                  type="number"
                  :min="0"
                  :step="1"
                  :max="popupState.quantity"
                  :state="errors.length ? 'invalid' : null"
                  class="text-right"
                  v-model="popupState.quantity_shortage" />
              </d-input-group>
              <div class="invalid-feedback text-center">
                {{ errors[0] }}
              </div>
            </div>
          </validation-provider>

          <validation-provider
            v-if="parseInt(popupState.quantity_shortage, 10) > 0"
            :rules="'required'"
            name="items-shortage"
            v-slot="{ errors }">
            <div class="w-100 mb-4">
              <d-textarea
                :value.prop="popupState.shortage_reason"
                v-model="popupState.shortage_reason"
                :state="errors.length ? 'invalid' : null"
                placeholder="CZEMU BRAK?">
              </d-textarea>
              <div class="invalid-feedback text-center">
                {{ errors[0] }}
              </div>
            </div>
          </validation-provider>

          <d-button
            theme="success"
            class="mt-2 w-100"
            size="sm"
            @click.prevent="validateForm"
            :disabled="popupState.saveInProgress">
            <div
              v-if="popupState.saveInProgress"
              class="spinner-border spinner-border-sm"
              role="status"></div>
            Aktualizuj
          </d-button>
        </validation-observer>
      </d-modal-body>
    </d-modal>
  </d-container>
</template>

<script>
import ListUtils from './../utils/ListUtils.js';
import FormUtils from './../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'dashboard',
  computed: {
    hasSewingItems () {
      return !!this.items.filter(item => item.process_type === 'SEWING').length;
    },
    hasPatternItems () {
      return !!this.items.filter(item => item.process_type === 'PATTERN').length;
    },
    sewingItems () {
      return this.items.filter(item => item.process_type === 'SEWING');
    },
    patternItems () {
      return this.items.filter(item => item.process_type === 'PATTERN');
    },
    sewingItemsCount () {
      return this.items.filter(item => item.process_type === 'SEWING').length;
    },
    patternItemsCount () {
      return this.items.filter(item => item.process_type === 'PATTERN').length;
    }
  },
  data() {
    return {
      updatePopupVisible: false,
      items: [],
      sewingDone: [],
      patternDone: [],
      loaded: false,
      itemsScheduleOpened: {},
      itemsSewingScheduleOpened: {},
      popupState: {
        itemID: 0,
        quantity: 0,
        quantity_done: 0,
        quantity_additional: 0,
        quantity_shortage: 0,
        done: 1,
        shortage_reason: '',
        saveInProgress: false
      }
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      this.loaded = false;

      ListUtils.loadItemsData(this, {
        endpoint: '/orders/products/processes/items/items',
        listField: ['items'],
        params: {
          pagination: 0
        },
        pagination: false
      });
    },
    dateColor (dateToCheck) {
      let timestamp = +new Date(dateToCheck);
      let currentTimestamp = +new Date();

      if (timestamp - currentTimestamp < 0) {
        return 'text-danger font-weight-bold';
      } else if (timestamp - currentTimestamp < 4 * 24 * 60 * 60 * 1000) {
        return 'text-warning';
      }

      return 'text-primary';
    },
    openPopup (item) {
      this.popupState.itemID = item.id;
      this.popupState.quantity = item.quantity;
      this.popupState.quantity_done = item.quantity_done;
      this.popupState.quantity_additional = 0;
      this.popupState.quantity_shortage = 0;
      this.popupState.shortage_reason = '';
      this.popupState.done = 1;
      this.popupState.saveInProgress = false;
      this.updatePopupVisible = true;
    },
    closePopup () {
      this.popupState.itemID = 0;
      this.popupState.quantity = 0;
      this.popupState.quantity_done = 0;
      this.popupState.quantity_additional = 0;
      this.popupState.quantity_shortage = 0;
      this.popupState.shortage_reason = '';
      this.popupState.done = 1;
      this.popupState.saveInProgress = false;
      this.updatePopupVisible = false;
    },
    validateForm () {
      FormUtils.validate(this.$refs['realisation-form'], this.submitForm);
    },
    submitForm () {
      this.popupState.saveInProgress = true;

      let formDataToSend = {
        execution: parseInt(this.popupState.done, 10),
        quantity_additional: parseInt(this.popupState.quantity_additional, 10),
        quantity_shortage: parseInt(this.popupState.quantity_shortage, 10)
      };

      if (parseInt(this.popupState.quantity_shortage, 10) > 0) {
        formDataToSend.shortage_reason = this.popupState.shortage_reason;
      }

      FormUtils.submit(this, {
        endpoint: '/orders/products/processes/items/store-execution/' + parseInt(this.popupState.itemID, 10),
        formData: formDataToSend,
        successTitle: 'Zapisano stan',
        successText: 'Stan realizacji wybranej pozycji został zaktualizowany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja stanu nie powiodła się. Spróbuj ponownie.',
        beforeSuccessAction: () => {
          this.closePopup();
        },
        beforeFailAction: () => {
          this.closePopup();
        },
        successAction: () => {
          this.loadData();
        }
      });
    },
    toggleSchedule (items, index, value) {
      Vue.set(items, index, value);
    }
  }
};
</script>

<style lang="scss">
.items-list dl {
  display: flex;
  flex-wrap: wrap;
  font-size: 80%!important;
  margin: 0;
  width: 300px;

  dt {
    width: 140px;
  }
  dd {
    margin: 0;
    width: calc(100% - 140px);
  }
}

.input-group[state="invalid"] + .invalid-feedback {
  display: block;
}

.is-visible-on-mobile {
  display: none!important;
}

.realisation-form-popup.modal .input-group-prepend {
  min-width: 60%;

  .input-group-text {
    justify-content: flex-end;
    width: 100%;
  }
}

@media (max-width: 1280px) {
  .is-hidden-on-mobile {
    display: none!important;
  }

  .is-visible-on-mobile {
    display: block!important;
  }

  .form-control {
    font-size: 16px!important;
  }
}

@media (max-width: 640px) {
  .page-header {
    padding-bottom: 10px!important;
    padding-top: 10px!important;
  }

  .page-header .page-title {
    font-size: 1.5rem!important;
  }

  .page-header .page-subtitle {
    font-size: .65rem!important;
  }

  .ui-title-text {
    margin-bottom: 0!important;
    text-align: left!important;
  }

  .ui-title-buttons {
    align-items: center;
    display: flex;
    justify-content: flex-end;

    .btn {
      margin-top: 0!important;
    }
  }

  .main-content > .main-content-container.container-fluid {
    padding-left: .75rem!important;
    padding-right: .75rem!important;
  }

  main > .main-content-container > .row.page-header:before {
    left: -0.75rem;
    width: calc(100% + 1.5rem);
  }
}

@media (max-width: 500px) {
  .page-header .page-title {
    font-size: 1.25rem!important;
  }

  .page-header .page-subtitle {
    font-size: .5rem!important;
  }

  .page-header .ui-button-label {
    display: none;
  }

  .row h4 {
    font-size: 20px;
  }

  .modal-header {
    padding-left: 1rem!important;
    padding-right: 1rem!important;
  }

  .modal-body.p-5 {
    padding: 1rem!important;
  }
}
</style>
